<template>
  <div v-if="links.length > 3">
    <ul class="pagination">
      <template v-for="(link, key) in links">
        <li class="page-item"><Link :key="`link-${key}`" class="page-link" :class="{ 'active': link.active }" :href="link.url" v-html="link.label" /></li>
      </template>
    </ul>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Link,
  },
  props: {
    links: Array,
  },
}
</script>
